// @flow
export const BOOKING_UNCHANGED = 'unchanged';
export const BOOKING_ADDED = 'added';
export const BOOKING_DELETED = 'deleted';
